<template>
  <Layout :config="config" v-loading="loading" class="bjkj">
    <template v-slot:header>
      <Header   :config="config.navMenuConfig"
          :menus="config.menuList"
          :menuClass="menuClass" v-if="flag" />
      <div class="menuBox pc">
        <NavMenu
          class="nav-menu"
          :config="config.navMenuConfig"
          :menus="config.menuList"
          :menuClass="menuClass"
          v-if="flag"
        />
      </div>
    </template>
    <template v-slot:main>
      <router-view v-if="flag" class="main-content"></router-view>
    </template>
    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>
import "../plugins/element/element.js";
import config from "../config.js";
import Layout from "@/components/Layout.vue";
import NavMenu from "@/components/NavMenu.vue";
import util from "@/libs/util.js";
import Header from "./Header.vue";
import Footer from "./Footer.vue";

export default {
  name: "Page",
  data() {
    return {
      config: {},
      list: null,
      menuList: [],
      loading: false,
      flag: true,
      menuClass: "subMenuClass",
    };
  },

  components: {
    Layout,
    NavMenu,
    Header,
    Footer,
  },
  created() {
    util.setIcon("favicon-bjkj.ico","北京信息科技大学马克思主义学院数字马院")
    this.config = config;
    console.log(this.config);
  },
  methods: {
  
  },
};
</script>
<style lang="scss" scoped>
@import "../variables.scss";
// @import "@/assets/font_1508885_gsgkry1qtlr/iconfont.css";
.banner {
  display: block;
  height: 200px;
  background-color: rgb(211, 220, 230);
}
.menu-container {
  background-color: $menu-color;
  height: 50px;
  line-height: 50px;
}
.menuBox {
  background-color: #a52a2a;
}
.nav-menu {
  position: relative;
  margin: 0px auto 0;
  border-radius: 4px;
  background-color: $menu-color;
  /deep/.menu-item:hover {
    background-color: $menu-hoverColor !important;
  }
  /deep/.menu-item.is-active {
    border: unset;
    background-color: $menu-activeColor !important;
  }
  /deep/.menu-item:hover .el-submenu__title {
    background-color: $menu-hoverColor !important;
  }
  /deep/.menu-item.is-active .el-submenu__title {
    border: unset !important;
    background-color: $menu-activeColor !important;
  }
  /deep/.menu-item{
    font-size: 18px;
  }
  /deep/ .el-submenu__title{
    font-size: 18px;
  }
}

.main-content {
  min-height: 100%;
}
@media (max-width: 767px) {
   /deep/.el-menu {
    background-color: $menumobile-activeColor !important;
  }
   /deep/.menu-item{
     background-color: $menumobile-activeColor !important;
  }
   /deep/.menu .menu-item.is-active {
    border: unset;
    background-color:$menumobile-activeColor  !important;
    color: $menumobile-activeTextColor !important;
  }
   /deep/.menu .menu-item:hover .el-submenu__title {
    background-color:$menumobile-activeColor !important;
    color: #888 !important;
  }
   /deep/.menu .menu-item {
    color: #888 !important;
  }
   /deep/.menu .menu-item.is-active .el-submenu__title {
    border: unset !important;
    background-color: $menumobile-activeColor !important;
    color:$menumobile-activeTextColor !important;
  }
   /deep/.el-submenu .el-menu-item {
    background-color: $menumobile-activeColor !important;
    color: #888 !important;
    height: 48px;
    line-height: 48px;
  }
  /deep/.menu .menu-item .el-submenu__title {
    background-color: $menumobile-activeColor !important;
    color: #888 !important;
  }
}
.main-content {
  min-height: 100%;
  background-color: #fff9f6;
  overflow-x: hidden;
}
@media (max-width: 767px) {
  .main-content {
    background-color: #fff;
  }
}
</style>
<style lang="scss">
@import "../variables.scss";
.subMenuClass .menu-item.is-active {
  background-color: $menu-activeColor !important;
}
.subMenuClass .menu-item:hover {
  background-color: $menu-hoverColor !important;
}
.bjkj {

  .can-click:hover .name {
    color: #a52a2a;
  }
  * {//去除IOS上点击时出现区域阴影
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent; /* For some Androids */
  }
}
</style>